import React, {Component} from 'react';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {isSysop, hasSectionAccess, hasSystemAccess} from '../shared/authFunctions';
import InventoryOrdersTable from '../components/InventoryOrdersTable';
import NoAccess from '../noAccess';
import FuseTheme from '../global/theme';
import Avatar from 'material-ui/Avatar';
import {Card, CardText} from 'material-ui/Card';
import Icon from 'material-ui/svg-icons/action/today';

export const fuseInventoryOrdersIcon = Icon;

const styles = {
    error: {fontSize: 16, color: FuseTheme.palette.errorColor},
};

/**
 * Landing Page with links to create Report Jobs and display existing Report Jobs
 *
 */
export class InventoryOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null,
            reportSearch: '',
            reportSelf: false,
            reportCategory: '',
            reportChoices: [],
            reportType: '',
        };
    }

    render() {
        const {
            errorMessage
        } = this.state;

        // User must be a Sysop, a Sysadmin with jakes system, all systems, and section inventory_orders
        if (!isSysop()) {
            if (!hasSystemAccess('jakes') || !hasSectionAccess('inventory_orders')) {
                return <NoAccess/>;
            }
        }

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Inventory Orders</span>;

        return (
            <div className="lists-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <span className="list-description hide-print">
                            <p>
                                View the list of Inventory Orders by Location below. You may view each Order's
                                products by location, and approve or reject that location's items for the Order.
                            </p>
                            <p>
                                If you have reviewed an order's items, you can generate the order if desired, or
                                delete it and run another Forecast Job for that location.
                            </p>
                        </span>

                        {/* Error and Messaging */}
                        {errorMessage &&
                            <div style={styles.error}>
                                <p>{errorMessage}</p>
                            </div>
                        }

                        {/* Existing Inventory Order Jobs */}
                        <InventoryOrdersTable/>

                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/views/InventoryOrders.js